import { render } from "./suportChat.vue?vue&type=template&id=765d9946&scoped=true"
import script from "./suportChat.vue?vue&type=script&lang=js"
export * from "./suportChat.vue?vue&type=script&lang=js"

import "./suportChat.vue?vue&type=style&index=0&id=765d9946&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765d9946"]])

export default __exports__